import React, { Suspense, useState, useEffect } from 'react'

import ErrorBoundary from 'components/ErrorBoundary'

/**
 *
 * @param {object} props
 * @param {React.ReactElement} props.fallback
 * @param {React.ReactElement} props.children
 * @param {React.ReactElement=} props.errorFallback
 * @param {number=} props.timeout
 */
export const SuspenseWithTimeout = ({ timeout, fallback, errorFallback, children, ...props }) => {
  return (
    <ErrorBoundary errorFallback={errorFallback || fallback}>
      <Suspense fallback={<Timeout timeout={timeout}>{fallback}</Timeout>} {...props}>
        {children}
      </Suspense>
    </ErrorBoundary>
  )
}

function Timeout({ timeout, children }) {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true)
    }, timeout)
    return () => clearTimeout(timer)
  }, [timeout])

  return shouldRender ? children : null
}

Timeout.defaultProps = {
  timeout: 1000,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SuspenseWithTimeout/index.js